module.exports = __webpack_public_path__ + "static/media/chevron-left.726065d3.svg";